import { useCallback } from 'react'
import { type StripeElementChangeEvent } from '@stripe/stripe-js'
import { type CardPaymentMethodEditorViewModel } from '@/features/billing/payment-methods/CardPaymentMethodEditorViewModel'
import { CardInput } from '@/features/billing/payment-methods/NewPaymentMethodDialog/CardPaymentMethodEditorContent/CardInput'
import { observer } from 'mobx-react-lite'

export interface CardInputContainerProps {
  vm: CardPaymentMethodEditorViewModel
  isDisabled: boolean
}

export const CardInputContainer = observer(function CardInputContainer({
  vm,
  isDisabled,
}: CardInputContainerProps) {
  const handleChange = useCallback(
    (event: StripeElementChangeEvent) => {
      vm.setCardError(event.error?.message || '')
    },
    [vm],
  )
  return (
    <CardInput
      isDisabled={isDisabled}
      error={vm.validation.getError('card')}
      onChange={handleChange}
      onReady={vm.setCard}
    />
  )
})
